import React, { ReactElement } from 'react';

import { InlineNotification } from '~/components/common/InlineNotification';

const DEFAULT_MSG = `a discount`;

interface AutoApplyCouponWarningProps {
  couponDesc: string | null;
}
export default React.memo(function AutoApplyCouponWarning({
  couponDesc,
}: Readonly<AutoApplyCouponWarningProps>): ReactElement {
  return (
    <div className="bg-lemon-light-40 text-sm">
      <InlineNotification type="warning">
        <p>
          <span className="font-bold">Heads up!</span> You&apos;re already
          getting {couponDesc ?? DEFAULT_MSG}. Applying any additional coupon
          will override your current discount.
        </p>
      </InlineNotification>
    </div>
  );
});
